module.exports = __webpack_public_path__ + "static/media/fvs_hamburgerKunsthalle_18.82715441.jpg";